import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  Autocomplete,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { rsUserData, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import Detail from "../../main/detail/Detail";
import { UseAccess } from "./UseAccess";
import { UseUser } from "../User/UseUser";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Access() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msUserData, setMsUserData] = useRecoilState(rsUserData);
  const { getAllUserList } = UseUser();
  const {
    Remove,
    getAllUserPermissions,
    setUserPermissions,
    UserPermissionsPermit,
  } = UseAccess();
  const [openDelete, setOpenDelete] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [sameUserId, setSameUserId] = useState();
  const [expanded, setExpanded] = useState([]);
  const [userRes, setUserRes] = useState();
  const [permissionRes, setPermissionRes] = useState();
  const [selectedId, setSelectedId] = useState("");
  const [pageList, setPageList] = useState([]);
  const [pageStateList, setPageStateList] = useState([]);
  const [selectedPermissionList, setSelectedPermissionList] = useState();
  const [selectedUser, setSelectedUser] = React.useState();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    UserPermissionsPermit(true);
  }, []);

  useEffect(() => {
    getAllUserList((users) => {
      setUserRes(users);
    });
  }, []);

  useEffect(() => {
    if (userRes && selectedId) {
      setSelectedUser(userRes.users.find((m) => m.id == selectedId));
    }
  }, [userRes, selectedId]);

  useEffect(() => {
    if (selectedUser) {
      setSelectedId(selectedUser.id);
    } else {
      setSelectedId(false);
    }
  }, [selectedUser]);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  function handlechangeSame(e, value) {
    if (value) {
      setSameUserId(value.id);
      setOpen(false);
    } else {
      setSameUserId(false);
    }
  }

  useEffect(() => {
    if (sameUserId) {
      getUserPermissions(sameUserId);
    }
  }, [sameUserId]);

  useEffect(() => {
    if (selectedId) {
      getUserPermissions(selectedId);
    }
  }, [selectedId]);

  useEffect(() => {
    if (pageStateList && permissionRes) {
      setSelectedPermissionList(
        permissionRes.map((elem, i) => {
          return (
            <TreeItem
              expanded={i.toString()}
              nodeId={i.toString()}
              label={elem.groupTitle}
              key={i}
              sx={{
                "& .muirtl-1mvpgmy-MuiTreeItem-content.Mui-focused": {
                  backgroundColor: "#fff",
                },
              }}
            >
              {PageChildes(elem.pages)}
            </TreeItem>
          );
        })
      );
    }
  }, [pageStateList]);

  function PageChildes(pages) {
    var test = [];
    pages.map((pageElem, j) => {
      test.push(
        <FormControlLabel
          sx={{ width: "100%", ml: 0.3 }}
          key={j}
          label={pageElem.pageTitle}
          control={
            <Checkbox
              checked={
                pageStateList.find((ps) => ps.pageId == pageElem.id).isPermit
              }
              onChange={(evt) => {
                handleCheckBoxChange(pageElem.id, evt.target.checked);
              }}
            />
          }
        />
      );
    });
    return test;
  }

  function handleCheckBoxChange(id, checked) {
    let temp = pageStateList.slice();
    temp.find((pageElem) => pageElem.pageId == id).isPermit = checked;
    setPageStateList(temp);
  }

  function getUserPermissions(id) {
    setProgress(true);
    getAllUserPermissions(
      id,
      (permissions, pageList, pageStateList) => {
        setPermissionRes(permissions);
        setPageList(pageList);
        setPageStateList(pageStateList);
      },
      true
    );
  }

  return (
    <Detail
      breadChilds={{
        title: "کاربران",
        childs: [{ name: msActiveMenu.pageTitle, url: "/useraccess" }],
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <ArrowCircleLeftOutlinedIcon color="secondary" />
        <Typography variant="body2" sx={{ ml: 1 }}>
          کاربر مورد نظر را جهت تنظیم سطوح دسترسی انتخاب نمایید :
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={userRes ? userRes.users : []}
          getOptionLabel={(state) =>
            state ? state.firstName + " " + state.lastName : ""
          }
          value={selectedUser ? selectedUser : ""}
          size="small"
          isOptionEqualToValue={(option, value) => option.value === value.value}
          sx={{ width: isSmall ? "70%" : "30%", my: 2 }}
          renderInput={(params) => <TextField {...params} label="کاربر" />}
          onChange={(evt, newValue) => {
            if (newValue) {
              setSelectedUser(newValue);
            } else {
              setSelectedUser();
            }
          }}
        />
        {selectedId ? (
          <Button
            sx={{ width: "100px" }}
            color="secondary"
            onClick={() => setOpen(true)}
            variant="contained"
          >
            مشابه کاربر
          </Button>
        ) : (
          ""
        )}
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent sx={{ height: "400px" }}>
            <Typography variant="body2">
              کاربر مورد نظر را انتخاب کنید
            </Typography>
            <Autocomplete
              color="secondary"
              disablePortal
              id="combo-box-demo"
              options={userRes ? userRes.users : []}
              getOptionLabel={(state) =>
                state ? state.firstName + " " + state.lastName : state.firstName
              }
              size="small"
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              sx={{ width: 300, m: 1 }}
              renderInput={(params) => <TextField {...params} label="کاربر" />}
              onChange={handlechangeSame}
            />
          </DialogContent>
        </Dialog>
      </Box>
      {selectedId ? (
        <TreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          defaultExpanded={[
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
          ]}
          sx={{ m: 1 }}
        >
          {selectedPermissionList}
        </TreeView>
      ) : (
        ""
      )}
      {selectedId ? (
        <Box sx={{ m: 1, display: "flex", justifyContent: "center" }}>
          <Button
            sx={{ mr: 2 }}
            onClick={() => {
              let temp = pageStateList.slice();
              var test2 = [];
              temp.map((tempInput) => {
                if (tempInput.isPermit == true) {
                  test2.push(tempInput.pageId);
                }
              });
              setProgress(true);

              setUserPermissions(test2, selectedId, () => {
                if (selectedId == msUserData.id) {
                  window.location.reload();
                  return;
                }
                setSelectedUser();
              });
            }}
            variant="contained"
            color="secondary"
          >
            ثبت سطوح دسترسی
          </Button>
          <Button
            onClick={() => setOpenDelete(true)}
            variant="contained"
            color="secondary"
          >
            حذف سطوح دسترسی
          </Button>
        </Box>
      ) : (
        ""
      )}
      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">توجه :</DialogTitle>
        <DialogContent>
          <Typography>آیا از حذف همه سطوح دسترسی مطمئن هستید ؟</Typography>
        </DialogContent>
        <DialogActions sx={{ m: 2 }}>
          <Button
            variant="text"
            onClick={() => {
              setProgress(true);
              Remove(selectedId, () => {
                getUserPermissions(selectedId);
                setOpenDelete(false);
              });
            }}
          >
            تایید
          </Button>
          <Button
            variant="text"
            color="secondary"
            onClick={() => setOpenDelete(false)}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </Detail>
  );
}
